{
  "R": [3, 255, 255, 255],
  "G": [0, 0, 255, 255],
  "B": [0, 0, 0, 255],
  "A": [0, 48, 96, 128],
  "I": [0, 95, 191, 255]
}
